import * as React from 'react';
import styled from 'react-emotion';
import { styles } from './styles';

export const BaseButton = styled('button')<React.InputHTMLAttributes<{}>>(() => {
  return styles.container;
});
